<fd-dialog [ngClass]="dialogClass">
  <fd-dialog-header>
    <h1 fd-title class="dialog-header">
      @if (headerGlyph) {
        <app-icon
          class="dialog-header-icon"
          [icon]="headerGlyph"
          size="lg"
        ></app-icon>
      }
      <span class="dialog-header-text">
        {{ headerText }}
        <span class="superscript">{{ superscriptHeaderText }}</span>
      </span>
    </h1>

    @if (showTopCancelButton) {
      <button
        tabindex="-1"
        fd-dialog-close-button
        class="cancel-btn"
        title="Close"
        [disabled]="busy"
        (click)="onCancel()"
      ></button>
    }
  </fd-dialog-header>

  <fd-dialog-body class="dialog-body">
    <div #scrollRef></div>
    <div class="column-container" [hidden]="!contentVisible">
      <fd-wizard contentHeight="auto" [appendToWizard]="false">
        <fd-wizard-navigation>
          <ul
            fd-wizard-progress-bar
            size="sm"
            role="list"
            aria-label="Wizard Steps"
          >
            @for (step of steps; track step; let i = $index) {
              <li
                fd-wizard-step
                [label]="step.title"
                [ariaLabel]="step.title"
                [status]="$any(step.status)"
                (statusChange)="statusChanged(i, $event)"
              >
                <fd-wizard-step-indicator>{{ i + 1 }}</fd-wizard-step-indicator>
                <fd-wizard-content size="md" contentBackground="transparent">
                  <div class="step-inner-container">
                    <ng-content *ngTemplateOutlet="step.template"></ng-content>
                  </div>
                </fd-wizard-content>
              </li>
            }
          </ul>
        </fd-wizard-navigation>
      </fd-wizard>
      <div class="strip-container" #strip tabindex="-1">
        @if (!!errorMsg) {
          <app-error-strip
            [errorText]="errorText"
            [errorMsg]="errorMsg"
          ></app-error-strip>
        }
      </div>
    </div>
    @if (showBusyIndicator) {
      <div class="busy-wrapper">
        <div class="busy-inner-wrapper">
          <fd-busy-indicator [loading]="true" size="l"></fd-busy-indicator>
          <div [innerHTML]="busyIndicatorText"></div>
        </div>
      </div>
    }
  </fd-dialog-body>

  @if (showFooter) {
    <fd-dialog-footer>
      <div fd-bar-left>
        <fd-button-bar
          [style.visibility]="isPrevButtonHidden ? 'hidden' : 'visible'"
          label="Back"
          fdType="transparent"
          [disabled]="busy"
          [fdCompact]="true"
          (click)="onPrevClick()"
          glyph="slim-arrow-left"
          id="dialog-back-btn"
          class="dialog-save-button uppercase-btn"
          ariaLabel="Back Transparent"
        >
        </fd-button-bar>
      </div>
      <div fd-bar-right>
        @if (!isNextButtonHidden) {
          <fd-button-bar
            [disabled]="!currentStep?.isValid || busy"
            label="Next"
            [title]="nextTitle()"
            fdType="transparent"
            [fdCompact]="true"
            (click)="onNextClick()"
            glyph="slim-arrow-right"
            glyphPosition="after"
            id="dialog-next-btn"
            class="dialog-save-button uppercase-btn"
            ariaLabel="Next"
          >
          </fd-button-bar>
        }
        @if (showCancelButton) {
          <fd-button-bar
            i18n-label="
              XBUT|Cancel button for the Session Expiry
              Dialog@@sessionExpiry.cancelButton"
            [label]="cancelText"
            fdType="transparent"
            [disabled]="busy"
            [fdCompact]="true"
            (click)="onCancel()"
            class="dialog-cancel-button uppercase-btn"
            id="dialog-cancel-btn"
            title="Cancel"
            ariaLabel="Cancel"
          >
          </fd-button-bar>
        }
        @if (!!saveButtonTemplate) {
          <ng-template *ngTemplateOutlet="saveButtonTemplate"></ng-template>
        } @else {
          @if (currentStepSignal()?.stepId !== "beforeBegin") {
            <fd-button-bar
              [label]="saveText"
              fdType="emphasized"
              [disabled]="!validationFn() || busy"
              [fdCompact]="true"
              (click)="this.save.emit($event)"
              id="dialog-submit-btn"
              class="dialog-save-button uppercase-btn"
              ariaLabel="OK Transparent"
            >
            </fd-button-bar>
          }
        }
      </div>
    </fd-dialog-footer>
  }
</fd-dialog>
